class EmailValidator {
    private readonly EMAIL_REG_EXP: RegExp = /^[0-9A-Za-z!#$%&'*+/=?^_`{|}~-]{1,64}(\.[[0-9A-Za-z!#$%&'*+/=?^_`{|}~\-\]]{1,64}){0,3}@[0-9A-Za-z-_]{2,63}(\.([0-9A-Za-z-_]){2,63}){1,3}$/

    public validateEmail(email: string): boolean {
        return this.EMAIL_REG_EXP.test(email);
    }
}
export default new EmailValidator();


// WEBPACK FOOTER //
// ./src/services/Validator/Email/Validator.ts